import { RadioField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { OptionContainer } from './option_container';
const radioButtonCss = "r1fa967c";
const RadioButton = forwardRef((props, ref) => <RadioField ref={ref} {...props} className={classNames(radioButtonCss, props.className)} />);
export const UnlimitedOption = ({
  spaceless = false
}) => <OptionContainer spaceless={spaceless}>
    <RadioButton name="periodType" value="unlimited" label={I18n.t('publisher.event_types.availability.booking_range_fieldset.unlimited_label')} />
  </OptionContainer>;

require("./unlimited_option.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./unlimited_option.js");